export const COUNTRIES = [
  { value: "", label: "" },
  { value: "FRA", label: "France" },
  { value: "AFG", label: "Afghanistan" },
  { value: "ZAF", label: "Afrique du Sud" },
  { value: "ALB", label: "Albanie" },
  { value: "DZA", label: "Algérie" },
  { value: "DEU", label: "Allemagne" },
  { value: "AND", label: "Andorre" },
  { value: "AGO", label: "Angola" },
  { value: "ATG", label: "Antigua-et-Barbuda" },
  { value: "SAU", label: "Arabie Saoudite" },
  { value: "ARG", label: "Argentine" },
  { value: "ARM", label: "Arménie" },
  { value: "ABW", label: "Aruba" },
  { value: "AUS", label: "Australie" },
  { value: "AUT", label: "Autriche" },
  { value: "AZE", label: "Azerbaïdjan" },
  { value: "BHS", label: "Bahamas" },
  { value: "BHR", label: "Bahreïn" },
  { value: "BGD", label: "Bangladesh" },
  { value: "BRB", label: "Barbade" },
  { value: "BEL", label: "Belgique" },
  { value: "BLZ", label: "Belize" },
  { value: "BMU", label: "Bermudes" },
  { value: "BTN", label: "Bhoutan" },
  { value: "MMR", label: "Birmanie" },
  { value: "BLR", label: "Biélorussie" },
  { value: "BOL", label: "Bolivie" },
  { value: "BIH", label: "Bosnie-Herzégovine" },
  { value: "BWA", label: "Botswana" },
  { value: "BRN", label: "Brunei" },
  { value: "BRA", label: "Brésil" },
  { value: "BGR", label: "Bulgarie" },
  { value: "BFA", label: "Burkina Faso" },
  { value: "BDI", label: "Burundi" },
  { value: "BEN", label: "Bénin" },
  { value: "KHM", label: "Cambodge" },
  { value: "CMR", label: "Cameroun" },
  { value: "CAN", label: "Canada" },
  { value: "CPV", label: "Cap Vert" },
  { value: "CHL", label: "Chili" },
  { value: "CHN", label: "Chine" },
  { value: "CYP", label: "Chypre" },
  { value: "COL", label: "Colombie" },
  { value: "COM", label: "Comores" },
  { value: "COG", label: "Congo" },
  { value: "COD", label: "Congo (Rép. dém.)" },
  { value: "PRK", label: "Corée du Nord" },
  { value: "KOR", label: "Corée du Sud" },
  { value: "CRI", label: "Costa Rica" },
  { value: "HRV", label: "Croatie" },
  { value: "CUB", label: "Cuba" },
  { value: "CUW", label: "Curaçao" },
  { value: "CIV", label: "Côte dIvoire" },
  { value: "DNK", label: "Danemark" },
  { value: "DJI", label: "Djibouti" },
  { value: "DMA", label: "Dominique" },
  { value: "EGY", label: "Egypte" },
  { value: "ARE", label: "Emirats arabes unis" },
  { value: "ECU", label: "Equateur" },
  { value: "ERI", label: "Erythrée" },
  { value: "ESP", label: "Espagne" },
  { value: "EST", label: "Estonie" },
  { value: "SWZ", label: "Eswatini" },
  { value: "USA", label: "Etats-Unis" },
  { value: "ETH", label: "Ethiopie" },
  { value: "FJI", label: "Fidji" },
  { value: "FIN", label: "Finlande" },
  { value: "GAB", label: "Gabon" },
  { value: "GMB", label: "Gambie" },
  { value: "GHA", label: "Ghana" },
  { value: "GIB", label: "Gibraltar" },
  { value: "GRD", label: "Grenade" },
  { value: "GRL", label: "Groenland" },
  { value: "GRC", label: "Grèce" },
  { value: "GUM", label: "Guam" },
  { value: "GTM", label: "Guatemala" },
  { value: "GIN", label: "Guinée" },
  { value: "GNB", label: "Guinée-Bissau" },
  { value: "GNQ", label: "Guinée-Équatoriale" },
  { value: "GUY", label: "Guyana" },
  { value: "GEO", label: "Géorgie" },
  { value: "HTI", label: "Haïti" },
  { value: "HND", label: "Honduras" },
  { value: "HKG", label: "Hong Kong (Chine)" },
  { value: "HUN", label: "Hongrie" },
  { value: "MUS", label: "Ile Maurice" },
  { value: "IMN", label: "Ile de Man" },
  { value: "CYM", label: "Iles Caïmans" },
  { value: "FRO", label: "Iles Féroé" },
  { value: "MNP", label: "Iles Mariannes du Nord" },
  { value: "MHL", label: "Iles Marshall" },
  { value: "SLB", label: "Iles Salomon" },
  { value: "TCA", label: "Iles Turques-et-Caïques" },
  { value: "VGB", label: "Iles Vierges britanniques" },
  { value: "IND", label: "Inde" },
  { value: "IDN", label: "Indonésie" },
  { value: "IRQ", label: "Irak" },
  { value: "IRN", label: "Iran" },
  { value: "IRL", label: "Irlande" },
  { value: "ISL", label: "Islande" },
  { value: "ISR", label: "Israël" },
  { value: "ITA", label: "Italie" },
  { value: "JAM", label: "Jamaïque" },
  { value: "JPN", label: "Japon" },
  { value: "JOR", label: "Jordanie" },
  { value: "KAZ", label: "Kazakhstan" },
  { value: "KEN", label: "Kenya" },
  { value: "KGZ", label: "Kirghizistan" },
  { value: "KIR", label: "Kiribati" },
  { value: "KOS", label: "Kosovo" },
  { value: "KWT", label: "Koweït" },
  { value: "LAO", label: "Laos" },
  { value: "LSO", label: "Lesotho" },
  { value: "LVA", label: "Lettonie" },
  { value: "LBN", label: "Liban" },
  { value: "LBR", label: "Liberia" },
  { value: "LBY", label: "Libye" },
  { value: "LIE", label: "Liechtenstein" },
  { value: "LTU", label: "Lituanie" },
  { value: "LUX", label: "Luxembourg" },
  { value: "MAC", label: "Macao (Chine)" },
  { value: "MKD", label: "Macédoine du Nord" },
  { value: "MDG", label: "Madagascar" },
  { value: "MYS", label: "Malaisie" },
  { value: "MWI", label: "Malawi" },
  { value: "MDV", label: "Maldives" },
  { value: "MLI", label: "Mali" },
  { value: "MLT", label: "Malte" },
  { value: "MAR", label: "Maroc" },
  { value: "MRT", label: "Mauritanie" },
  { value: "MEX", label: "Mexique" },
  { value: "FSM", label: "Micronésie" },
  { value: "MDA", label: "Moldavie" },
  { value: "MCO", label: "Monaco" },
  { value: "MNG", label: "Mongolie" },
  { value: "MNE", label: "Monténégro" },
  { value: "MOZ", label: "Mozambique" },
  { value: "NAM", label: "Namibie" },
  { value: "NRU", label: "Nauru" },
  { value: "NIC", label: "Nicaragua" },
  { value: "NER", label: "Niger" },
  { value: "NGA", label: "Nigéria" },
  { value: "NOR", label: "Norvège" },
  { value: "NZL", label: "Nouvelle-Zélande" },
  { value: "NPL", label: "Népal" },
  { value: "OMN", label: "Oman" },
  { value: "UZB", label: "Ouzbékistan" },
  { value: "PAK", label: "Pakistan" },
  { value: "PLW", label: "Palaos" },
  { value: "PAN", label: "Panama" },
  { value: "PNG", label: "Papouasie-Nouvelle-Guinée" },
  { value: "PRY", label: "Paraguay" },
  { value: "NLD", label: "Pays-Bas" },
  { value: "PHL", label: "Philippines" },
  { value: "POL", label: "Pologne" },
  { value: "PRI", label: "Porto Rico" },
  { value: "PRT", label: "Portugal" },
  { value: "PER", label: "Pérou" },
  { value: "QAT", label: "Qatar" },
  { value: "CA-QC", label: "Québec" },
  { value: "ROU", label: "Roumanie" },
  { value: "GBR", label: "Royaume-Uni" },
  { value: "RUS", label: "Russie" },
  { value: "RWA", label: "Rwanda" },
  { value: "CAF", label: "République centrafricaine" },
  { value: "DOM", label: "République dominicaine" },
  { value: "CZE", label: "République tchèque" },
  { value: "SXM", label: "Saint Martin (partie néerlandaise)" },
  { value: "KNA", label: "Saint-Christophe-et-Niévès" },
  { value: "SMR", label: "Saint-Marin" },
  { value: "MAF", label: "Saint-Martin (partie française)" },
  { value: "VCT", label: "Saint-Vincent-et-les-Grenadines" },
  { value: "LCA", label: "Sainte-Lucie" },
  { value: "SLV", label: "Salvador" },
  { value: "WSM", label: "Samoa" },
  { value: "ASM", label: "Samoa américaines" },
  { value: "STP", label: "Sao Tomé-et-Principe" },
  { value: "SRB", label: "Serbie" },
  { value: "SYC", label: "Seychelles" },
  { value: "SLE", label: "Sierra Leone" },
  { value: "SGP", label: "Singapour" },
  { value: "SVK", label: "Slovaquie" },
  { value: "SVN", label: "Slovénie" },
  { value: "SOM", label: "Somalie" },
  { value: "SDN", label: "Soudan" },
  { value: "SSD", label: "Soudan du Sud" },
  { value: "LKA", label: "Sri Lanka" },
  { value: "CHE", label: "Suisse" },
  { value: "SUR", label: "Suriname" },
  { value: "SWE", label: "Suède" },
  { value: "SYR", label: "Syrie" },
  { value: "SEN", label: "Sénégal" },
  { value: "TJK", label: "Tadjikistan" },
  { value: "TZA", label: "Tanzanie" },
  { value: "TWN", label: "Taïwan" },
  { value: "TCD", label: "Tchad" },
  { value: "PSE", label: "Territoires palestiniens" },
  { value: "THA", label: "Thaïlande" },
  { value: "TLS", label: "Timor oriental" },
  { value: "TGO", label: "Togo" },
  { value: "TON", label: "Tonga" },
  { value: "TTO", label: "Trinité et Tobago" },
  { value: "TUN", label: "Tunisie" },
  { value: "TKM", label: "Turkménistan" },
  { value: "TUR", label: "Turquie" },
  { value: "TUV", label: "Tuvalu" },
  { value: "UGA", label: "Uganda" },
  { value: "UKR", label: "Ukraine" },
  { value: "URY", label: "Uruguay" },
  { value: "VUT", label: "Vanuatu" },
  { value: "VAT", label: "Vatican" },
  { value: "VEN", label: "Venezuela" },
  { value: "VNM", label: "Viêt Nam" },
  { value: "YEM", label: "Yémen" },
  { value: "ZMB", label: "Zambie" },
  { value: "ZWE", label: "Zimbabwe" }
];
